export default {
	filtro: {
		razaoSocial: null,
		idProcesso: null,
		classificacao: null,
		nomeFantasia: null,
		idsFornecedores: [],
		numeroEditais: [],
		idsTipos: [],
	},
	paginacao: {
		rowsPerPage: 100,
	},
	modelFiltro: {
		id: null,
		razaoSocial: null,
		nomeFantasia: null,
		documento: null,
		situacao: null,
	},
}
